/**
 * The generated `src/api` contracts predate the backend's per-client timeline color.
 * Intersect a DTO with these until the swagger spec is regenerated, then delete them —
 * same lifecycle as `WithSorts<T>` in `sorting.ts`.
 *
 * `WithTimelineColor` — the client entity itself (`ClientRequest`, `ClientResponse`,
 * `ClientListItemResponse`).
 * `WithSegmentClientInfo` — `TimelineSegment` from `POST /spaces/timeline` and
 * `POST /advertisingPackages/timeline`: color and display name, resolved server-side for
 * location viewers only.
 * `WithClientTimelineColor` — `OrderBookingResponse` / `OrderPackageBookingResponse` details
 * rows: color only, the name already ships as `companyName`.
 */
export type WithTimelineColor<T> = T & { timelineColor?: string | null };

export type WithSegmentClientInfo<T> = T & { clientTimelineColor?: string; clientName?: string };

export type WithClientTimelineColor<T> = T & { clientTimelineColor?: string };

export const TIMELINE_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const isValidTimelineColor = (value: unknown): value is string =>
  typeof value === 'string' && TIMELINE_COLOR_PATTERN.test(value);
